import firebase from "firebase/compat/app"
import { functions } from "../../Firestore"
import { httpsCallable } from "firebase/functions"
import { getAuth } from "firebase/auth"
import { GPT_5, TEXT_EMBEDDING_ADA_002 } from "./chatGenerationServices"

const AUSTRALIA_SOUTHEAST1 = "australia-southeast1"

const obtainCustomClaims = async () => {
  const obtainClaims = httpsCallable(functions, "getClaims")

  if (getAuth().currentUser) {
    const user = firebase.auth().currentUser

    console.log(
      "obtain claims for user",
      user.email,
      "email verified?",
      user.emailVerified
    )

    return await getAuth()
      .currentUser.getIdTokenResult(true)
      .then(async (token) => {
        const payload = { idToken: token }

        try {
          const claimsResult = await obtainClaims(payload)

          console.log("%cobtained claims", "color:pink", { claimsResult })

          return claimsResult
        } catch (err) {
          return console.error("Error calling claims", err)
        }
      })
  } else {
    console.log("obtainCustomClaims", "no current user")
  }
  return {}
}

const testGen2func = async () => {
  const func = httpsCallable(functions, "testGen2bFunc")

  const result = await func({ value: "hello", XXXXXXXXXXXXXXXXX: "12345678" })
  console.log("testGen2func", result)
}

/**
 *
 * @param {*} input | The input to create the embedding for
 * @returns
 */
// const createEmbedding = async (input) => {
//   const createEmbeddingFunc = httpsCallable(functions, "createEmbedding")

//   const payload = { input: input, model: TEXT_EMBEDDING_ADA_002 }

//   try {
//     const queryResult = await createEmbeddingFunc(payload)

//     //console.log("%ccreateEmbedding", "color:green", queryResult)

//     return queryResult
//   } catch (err) {
//     console.error("Error calling createEmbedding", err)
//   }
// }

const createEmbedding = async (input, model = "text-embedding-3-small") => {
  const fn = httpsCallable(functions, "createEmbedding")
  const result = await fn({ input, model }) // result.data is server payload

  if (!result?.data) {
    throw new Error("[client createEmbedding] No payload from callable")
  }
  const { status, error, data } = result.data

  if (status !== "success") {
    throw new Error(`[client createEmbedding] ${error || "unknown error"}`)
  }

  // return EXACT shape expected by modelServices strict code:
  // { data: [ { embedding } ] }
  return { data }
}

const submitToolOutputs = async ({
  threadId,
  runId,
  toolCallId,
  toolOutput,
}) => {
  const func = httpsCallable(functions, "submitToolOutputs", {
    timeout: 300000,
  })

  try {
    const result = await func({ threadId, runId, toolCallId, toolOutput })

    return result
  } catch (err) {
    console.error("Error calling submitToolOutputs", err)
    throw err
  }
}

const createOpenAIVectorStore = async ({ name, fileIds }) => {
  const func = httpsCallable(functions, "createVectorStore", {
    timeout: 300000,
  })

  try {
    const result = await func({ name, fileIds })
    return result
  } catch (err) {
    console.error("Error calling createVectorStore", err)
    throw err
  }
}

const deleteOpenAIFile = async ({ fileId }) => {
  const func = httpsCallable(functions, "deleteFile", { timeout: 300000 })

  try {
    const result = await func({ fileId })
    return result
  } catch (err) {
    console.error("Error calling deleteFile", err)
    throw err
  }
}

const createOpenAIFile = async ({ fileStoragePath }) => {

  console.log("%ccreating file for openai", "color:orange", { fileStoragePath })
  const func = httpsCallable(functions, "createFile", { timeout: 300000 })

  try {
    const result = await func({ fileStoragePath })
    return result
  } catch (err) {
    console.error("Error calling createFile", err)
    throw err
  }
}

/**
 * Add a new vector store file to the OpenAI vector store
 *
 * @param {*} param0
 * @returns
 */
const createOpenAIVectorStoreFile = async ({ vsId, fileId }) => {
  const func = httpsCallable(functions, "createVectorStoreFile", {
    timeout: 300000,
  })

  try {
    const result = await func({ vsId, fileId })
    return result
  } catch (err) {
    console.error("Error calling createVectorStoreFile", err)
    throw err
  }
}

const createResponse = async ({
  prompt,
  model = GPT_5,
  reasoning = { effort: "medium" },
  previous_response_id,
  store,
  tools,
  jsonSchema, // { name, description?, parameters, strict? } ONLY
  top_p,
  max_output_tokens,
  presence_penalty,
  frequency_penalty,
  metadata,
}) => {
  const func = httpsCallable(functions, "createResponse", { timeout: 300000 })

  let text
  if (jsonSchema) {
    // Strict key set: disallow 'schema' and any unknowns
    const allowed = new Set(["name", "description", "parameters", "strict"])
    const keys = Object.keys(jsonSchema)
    const extra = keys.filter((k) => !allowed.has(k))
    if (extra.length) {
      throw new Error(
        `jsonSchema has unsupported keys: ${extra.join(
          ", "
        )}. Allowed: name, description, parameters, strict`
      )
    }

    if (!jsonSchema.name || typeof jsonSchema.name !== "string") {
      throw new Error("jsonSchema.name is required and must be a string")
    }
    if (
      !jsonSchema.parameters ||
      typeof jsonSchema.parameters !== "object" ||
      Array.isArray(jsonSchema.parameters)
    ) {
      throw new Error("jsonSchema.parameters is required and must be an object")
    }

    // Convert parameters -> schema (single place)
    text = {
      format: {
        type: "json_schema",
        name: jsonSchema.name,
        description: jsonSchema.description,
        strict: jsonSchema.strict ?? true,
        schema: jsonSchema.parameters, // <- conversion happens here
      },
    }
  }

  const payload = {
    prompt,
    model,
    reasoning:
      typeof reasoning === "string" ? { effort: reasoning } : reasoning,
    ...(previous_response_id !== undefined && { previous_response_id }),
    ...(store !== undefined && { store }),
    ...(tools !== undefined && { tools }),
    ...(text !== undefined && { text }),
    ...(top_p !== undefined && { top_p }),
    ...(max_output_tokens !== undefined && { max_output_tokens }),
    ...(presence_penalty !== undefined && { presence_penalty }),
    ...(frequency_penalty !== undefined && { frequency_penalty }),
    ...(metadata !== undefined && { metadata }),
  }

  try {
    const result = await func(payload)
    console.log("%ccreateResponse", "color:lightblue", { result })
    return result.data
  } catch (err) {
    console.log("%cError calling createResponse", "color:yellow", { err })
    throw err
  }
}

const deleteOpenAIVectorStoreFile = async ({ vsId, fileId }) => {
  const func = httpsCallable(functions, "deleteVectorStoreFile", {
    timeout: 300000,
  })

  try {
    const result = await func({ vsId, fileId })
    return result
  } catch (err) {
    console.error("Error calling deleteVectorStoreFile", err)
    throw err
  }
}

const listVectorStoreFiles = async ({ vsId }) => {
  const func = httpsCallable(functions, "listVectorStoreFiles", {
    timeout: 300000,
  })

  try {
    const result = await func({ vsId })
    return result
  } catch (err) {
    console.error("Error calling listVectorStoreFiles", err)
    throw err
  }
}

const deleteOpenAIVectorStore = async ({ vsId }) => {
  const func = httpsCallable(functions, "deleteVectorStore", {
    timeout: 300000,
  })

  try {
    const result = await func({ vsId })
    return result
  } catch (err) {
    console.error("Error calling deleteVectorStore", err)
    throw err
  }
}

const retrieveFile = async ({ fileId: fileId }) => {
  const func = httpsCallable(functions, "retrieveFile", {
    timeout: 300000,
  })

  try {
    const queryResult = await func({ fileId: fileId })

    console.log("%cretrieveFile", "color:lightblue", queryResult)

    return queryResult.data.response
  } catch (err) {
    console.error("Error calling retrieveFile", err)
    throw err
  }
}

const getOpenAiModels = async (text) => {
  const getModelsFunc = httpsCallable(functions, "getOpenAiModels")

  const payload = {}

  try {
    const queryResult = await getModelsFunc(payload)

    console.log("%cgetOpenAiModels", "color:green", queryResult)

    return queryResult
  } catch (err) {
    console.error("Error calling getOpenAiModels", err)
  }
}

// This is the convention by which a cloud function indicates an error has occurred
const isError = (funcResult) => {
  return funcResult.data?.status?.type === "error"
}

const getMessage = (funcResult) => {
  return funcResult.data?.status?.message
}

const queryProjectsByAccountId = async (accountId) => {
  const queryProjects = httpsCallable(functions, "queryProjectsByAccountId")

  const payload = { accountId }

  const queryResult = await queryProjects(payload)

  console.log("queryProjectsByAccountId", queryResult)

  return queryResult
}

const copyDefaultRules = async () => {
  const copyRules = httpsCallable(functions, "copyDefaultRules")

  const payload = {}

  const result = await copyRules(payload)

  return result
}

/**
 * @param {*} viewName The name of the view to query in BigQuery
 * @returns data from BigQuery
 */
const queryViewByAccountId = async (viewName) => {
  // The account id value is determined bty the function server-side
  const query = httpsCallable(functions, "queryViewByAccountId")

  const payload = { viewName }

  const queryResult = await query(payload)

  console.log("queryViewByAccountId", queryResult)

  return queryResult
}

const processInvite = async () => {
  const processInvite = httpsCallable(functions, "processInvite")

  const payload = {}

  const inviteResult = await processInvite(payload)

  return inviteResult
}

const createUserAndGetToken = async (email, password) => {
  const func = httpsCallable(functions, "createUserAndGetToken")

  const result = await func({ email, password })

  return result.data
}

const validateQRCodeOTPAndGetToken = async ({
  email,
  password,
  usePassword,
  otp,
}) => {
  const validateQRCode = httpsCallable(
    functions,
    "validateQRCodeOTPAndGetToken"
  )

  // seeking for result.data.token to be the Firebase token
  const result = await validateQRCode({ email, otp, password, usePassword })

  return result
}

const validateOTPAndGetToken = async (email, otp, usePassword, password) => {
  const validateOTP = httpsCallable(functions, "validateOTPAndGetToken")

  const validateProps = { email, otp }

  if (usePassword) {
    validateProps.password = password
    validateProps.usePassword = usePassword
  }

  // seeking for result.data.token to be the Firebase token
  const result = await validateOTP(validateProps)

  return result
}

// Handles validation of OTPs sent via email or SMS, even though cloud function name says email only
const isEmailOrSMSOTPCorrect = async (email, otp) => {
  const isOTPCorrect = httpsCallable(functions, "isEmailOTPCorrect")

  const result = await isOTPCorrect({ email, otp })

  return result.data
}

const isQROTPCorrect = async (otp, email) => {
  const func = httpsCallable(functions, "isQROTPCorrect")

  const result = await func({ otp, email })

  return result.data
}

const generateTotpKey = async (email) => {
  const func = httpsCallable(functions, "generateTotpKey")

  const payload = { email }

  const result = await func(payload)

  return result
}

const createAndSendOTPViaEmail = async ({ email }) => {
  const createAndSendOTP = httpsCallable(functions, "createAndSendOTPMessage")

  return await createAndSendOTP({ email: email })
}

const queryAuditEvents = async () => {
  const queryFunc = httpsCallable(functions, "queryAuditEvents")

  const payload = {}

  const result = await queryFunc(payload)

  return result
}

const createAndSendOTPViaSMS = async ({ email, phone }) => {
  const createAndSendOTP = httpsCallable(functions, "sendSMSOTP")

  return await createAndSendOTP({ email: email, phone: phone })
}

const getUserAuthenticationMethods = async ({ email }) => {
  const geAuthenticationMethods = httpsCallable(functions, "getUserAuthMethods")

  console.log("%cget authentication methods", "color:pink", email)

  const result = geAuthenticationMethods({ email })

  return result
}

const createTotpURI = async (email) => {
  const getTotpURI = httpsCallable(functions, "createTOTPURI")

  const payload = { email }

  const result = await getTotpURI(payload)

  return result
}

const verifyTotpToken = async (token) => {
  const verify = httpsCallable(functions, "verifyTotpToken")

  const payload = { token }

  const result = await verify(payload)

  return result
}

//const test01 = httpsCallable(functions, "test01")

//const test02 = httpsCallable(functions, "test02")

const checkUserExists = httpsCallable(functions, "checkIfUserExists")

const sendEmailMessage = async ({ to, subject, text, html }) => {
  const sendMsg = httpsCallable(functions, "sendEmailMessage")

  const payload = { to, subject, text, html }

  const result = await sendMsg(payload)

  return result
}

const refreshUserToken = () => {
  let callback = null
  let metadataRef = null

  console.log("refreshUserToken")

  firebase.auth().onAuthStateChanged((user) => {
    if (callback) {
      metadataRef.off("value", callback)
    }
    if (user) {
      metadataRef = firebase
        .database()
        .ref("metadata/" + user.uid + "/refreshTime")
      callback = (snapshot) => {
        user.getIdToken(true)
      }
      metadataRef.on("value", callback)
    }
  })
}

export {
  obtainCustomClaims,
  refreshUserToken,
  checkUserExists,
  processInvite,
  isError,
  getMessage,
  createTotpURI,
  verifyTotpToken,
  validateQRCodeOTPAndGetToken,
  testGen2func,
  validateOTPAndGetToken,
  generateTotpKey,
  createAndSendOTPViaEmail,
  createAndSendOTPViaSMS,
  queryAuditEvents,
  createUserAndGetToken,
  sendEmailMessage,
  copyDefaultRules,
  createEmbedding,
  deleteOpenAIFile,
  createOpenAIFile,
  createResponse,
  listVectorStoreFiles,
  createOpenAIVectorStoreFile,
  deleteOpenAIVectorStoreFile,
  createOpenAIVectorStore,
  deleteOpenAIVectorStore,
  retrieveFile,
  submitToolOutputs,
  getOpenAiModels,
  getUserAuthenticationMethods,
  // Reporting methods
  queryProjectsByAccountId,
  queryViewByAccountId,
  isEmailOrSMSOTPCorrect,
  isQROTPCorrect,
  AUSTRALIA_SOUTHEAST1,
}
